import apiClient from '@/config/api';

export interface LandingDailyRow {
  day: string;
  page: string;
  pv: number;
  uv: number;
}

export interface LandingTotalsRow {
  page: string;
  pv: number;
  uv: number;
  unique_ip: number;
}

export interface LandingPlatformRow {
  platform: string;
  pv: number;
}

export interface LandingReferrerRow {
  referrer: string;
  pv: number;
}

export interface LandingStats {
  days: number;
  daily: LandingDailyRow[];
  totals: LandingTotalsRow[];
  byPlatform: LandingPlatformRow[];
  topReferrers: LandingReferrerRow[];
}

export interface LandingVisit {
  id: string;
  page: string;
  ip: string | null;
  userAgent: string | null;
  platform: string | null;
  referrer: string | null;
  sessionId: string | null;
  lang: string | null;
  screen: string | null;
  createdAt: string;
}

export const landingApi = {
  stats: async (days = 30): Promise<LandingStats> => {
    const res = await apiClient.get('/admin/landing/stats', { params: { days } });
    return res.data.data;
  },
  visits: async (limit = 50, page?: string): Promise<LandingVisit[]> => {
    const res = await apiClient.get('/admin/landing/visits', { params: { limit, page } });
    return res.data.data;
  },
};
